import { render, staticRenderFns } from "./OrderDeta.vue?vue&type=template&id=7b0ac29b&scoped=true&"
import script from "./OrderDeta.vue?vue&type=script&lang=js&"
export * from "./OrderDeta.vue?vue&type=script&lang=js&"
import style0 from "./OrderDeta.vue?vue&type=style&index=0&id=7b0ac29b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0ac29b",
  null
  
)

export default component.exports